import { Row } from '@tanstack/react-table'

import { Filter, FilterType, Log } from '@/types/logs'

const filterCodes = (row: Log, codes: string[] = []): boolean => !codes.length || codes.includes(row.code)

export const filterLogsByType = (
    row: Row<Log>,
    _: string,
    filter: Filter & { codesMap: Record<string, string> }
): boolean => {
    const log = row.original

    if (!filterCodes(log, filter.value)) {
        return false
    }

    if (filter.type == FilterType.All) {
        return true
    }

    return filter.codesMap ? filter.codesMap[log.code] === (filter.type as string) : true
}
